import StringInput from "../../Control/InputBox/StringInput"
import { ColumnLabel } from "../../Layout/ColumnLabel"

export type TextSelectorProps = {
    name: string | null,
    effectText: string | null,
    updateName: (value: string | null) => void,
    updateEffectText: (value: string | null) => void,
    onEnterPress: () => void
}

export function TextSelector(props: TextSelectorProps) {
    return (
        <ColumnLabel
            label="Text"
            classNames={{ column2: "flex flex-col md:flex-row gap-1" }}
        >
            <StringInput
                className="flex-1"
                onEnterPress={props.onEnterPress}
                onChange={(value) => props.updateName(value)}
                value={props.name}
                placeholder="Name" />

            <StringInput
                className="flex-1"
                onEnterPress={props.onEnterPress}
                onChange={(value) => props.updateEffectText(value)}
                value={props.effectText}
                placeholder="Effect Text" />
        </ColumnLabel>
    )
}